const initialState = {
    performancedetails: [],
    updategraphbar: false,
};

const performancedetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_PERFORMANCE_DETAILS':
            return {
                ...state,
                performancedetails: action.payload,
            };
            case 'UPDATE_GRAPH_ACTION':
                return {
                  ...state,
                  updategraphbar: action.payload,
                };
        default:
            return { ...state };
    }
};
export default performancedetailsReducer;